import React from "react";
import { NAMED_ICONS } from "./serviceIcons";

const StatIcon = ({ icon }) => {
  if (!icon) return null;
  const NamedIcon = NAMED_ICONS[icon];
  if (NamedIcon) {
    return (
      <span
        className="inline-flex items-center justify-center w-9 h-9 rounded-md mb-3"
        style={{ backgroundColor: "#fce7f0" }}
      >
        <NamedIcon className="w-4 h-4" style={{ color: "#db0058" }} />
      </span>
    );
  }
  return (
    <img src={icon} alt="" aria-hidden="true" className="w-10 h-10 mb-3" />
  );
};

const ServiceStats = ({ items = [], variant = "plain" }) => {
  if (!items.length) {
    return null;
  }

  if (variant === "cards") {
    return (
      <dl className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {items.map((stat, index) => (
          <div
            key={stat.label || index}
            className="bg-gray-50 border border-gray-200 rounded-lg p-4 sm:p-5 text-center"
          >
            <StatIcon icon={stat.icon} />
            <dd className="text-lg sm:text-xl font-bold text-gray-900 break-words">
              {stat.prefix}
              {stat.value}
              {stat.suffix}
            </dd>
            <dt className="mt-1 text-xs sm:text-sm text-gray-600 leading-snug">
              {stat.label}
            </dt>
          </div>
        ))}
      </dl>
    );
  }

  return (
    <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10">
      {items.map((stat, index) => (
        <div key={stat.label || index} className="text-center sm:text-left">
          {stat.icon && !NAMED_ICONS[stat.icon] && (
            <img
              src={stat.icon}
              alt=""
              aria-hidden="true"
              className="w-10 h-10 mx-auto sm:mx-0 mb-3"
            />
          )}
          <dd
            className="text-3xl sm:text-4xl md:text-5xl font-bold break-words"
            style={{ color: "#db0058" }}
          >
            {stat.prefix}
            {stat.value}
            {stat.suffix}
          </dd>
          <dt className="mt-2 text-base sm:text-lg font-medium text-gray-900">
            {stat.label}
          </dt>
          {stat.supportingText && (
            <p className="mt-1 text-sm text-gray-600">{stat.supportingText}</p>
          )}
        </div>
      ))}
    </dl>
  );
};

export default ServiceStats;
